export { default } from './modules/RelativeTimeFormat'